import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { CheckIcon } from 'lucide-react';

const YesNoWidget = ({ onAnswer, disabled, initialValue = null }) => {
  const intl = useIntl();
  const [selected, setSelected] = useState(initialValue);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    setSelected(initialValue);
    setHasSubmitted(false);
  }, [initialValue]);

  const handleSelect = (answer) => {
    setSelected(answer);
    setHasSubmitted(true);
    setTimeout(() => {
      onAnswer({ value: answer });
    }, 300);
  };

  return (
    <div className="flex gap-2">
      <Button
        onClick={() => handleSelect('yes')}
        disabled={disabled || hasSubmitted}
        variant={selected === 'yes' ? 'primary' : 'outline'}
        className="flex-1 h-9 text-sm"
      >
        {selected === 'yes' && <CheckIcon className="h-3.5 w-3.5 mr-1.5" />}
        {intl.formatMessage({ id: 'succession.plans.widget_yes' })}
      </Button>
      <Button
        onClick={() => handleSelect('no')}
        disabled={disabled || hasSubmitted}
        variant={selected === 'no' ? 'primary' : 'outline'}
        className="flex-1 h-9 text-sm"
      >
        {selected === 'no' && <CheckIcon className="h-3.5 w-3.5 mr-1.5" />}
        {intl.formatMessage({ id: 'succession.plans.widget_no' })}
      </Button>
    </div>
  );
};

export default YesNoWidget;
